import React, { Component } from 'react';
import { Button, TextField, SelectField, DropdownMenu, ListItem } from 'react-md';

import ZSelectField from '../Utility/ZSelectField';
import ZDropdownMenu from '../Utility/ZDropdownMenu';

import MetricsFlashItem from './MetricsFlashItem';

import PermissionManager from '../../managers/PermissionManager'

export default class MetricsTopBar extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {
            isSearchFocused: false,
            isSearchDropped: false
        }

        this.handleSearch = this.handleSearch.bind(this);
        this.handleSearchFocus = this.handleSearchFocus.bind(this);
        this.handleSearchDropdown = this.handleSearchDropdown.bind(this);
        this.toggleSearch = this.toggleSearch.bind(this);
        this.toggleSearchDropped = this.toggleSearchDropped.bind(this);
        this.generateFlashItems = this.generateFlashItems.bind(this);

        this.renderPhone = this.renderPhone.bind(this);
        this.renderDesktop = this.renderDesktop.bind(this);

        this.pm = new PermissionManager();
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    handleSearch(value, event) {
        this.props.handleSearch(value, event);
    }

    handleSearchFocus(is) {
        this.setState({ isSearchFocused: is });
    }

    handleSearchDropdown(setting) {
        this.props.handleSearchTop(setting);
    }

    toggleSearch() {
        if (this.state.isSearchDropped) {
            this.toggleSearchDropped();
        }
        this.props.toggleSearch();
    }

    toggleSearchDropped() {
        this.setState({ isSearchDropped: !this.state.isSearchDropped });
    }

    generateFlashItems() {
        let genItems = [];
        // let chatAdd = 'ALL';
        let chatAdd = '';
        if (this.props.userType === 0 || this.props.canCreateMetricGroups || this.props.isGroupsMode) {
            genItems.push((<MetricsFlashItem onClick={this.props.toggleGroupsMode} closeMenuOnClick icon="group" text={this.props.isGroupsMode ? "Turn Groups Mode Off" : "Turn Groups Mode On"} add={''} />));
        }
        if (this.props.userType === 5 && this.props.screenContext.screen != 'allemp' && zzDataCache.account != null && zzDataCache.account.isLinked) {
            genItems.push((<MetricsFlashItem onClick={this.props.goToMe} closeMenuOnClick icon="person" text="Go To Me" add={''} />));
        }
        if (!this.props.employeeLocked) {

            if (this.props.hasDistricts && this.props.screenContext.screen != 'dists' && this.pm.hasAccess(this.pm.PERMISSIONS.METRICS_ALLLOCATIONS)) {
                genItems.push((<MetricsFlashItem onClick={this.props.changeScreen.bind(null, "dists")} closeMenuOnClick icon="location_city" text={"All " + (this.props.isGroupsMode ? "Groups" : "Districts")} add={''} />));
            }
            if (this.props.screenContext.screen != 'locs' && this.pm.hasAccess(this.pm.PERMISSIONS.METRICS_ALLLOCATIONS)) {
                genItems.push((<MetricsFlashItem onClick={this.props.changeScreen.bind(null, "locs")} closeMenuOnClick icon="store_mall_directory" text="All Locations" add={''} />));
            }
            if (this.props.screenContext.screen != 'allemps' && this.pm.hasAccess(this.pm.PERMISSIONS.METRICS_ALLPEEPS)) {
                genItems.push((<MetricsFlashItem onClick={this.props.changeScreen.bind(null, "allemps")} closeMenuOnClick icon="all_peeps" text="All Staff" add={''} />));
            }

            let isNotBlurred = false;
            if (this.props.accountInfo != undefined && this.props.accountInfo != null) {
                isNotBlurred = (!this.props.accountInfo.isEmployeeBlurred || (this.props.accountInfo.isEmployeeBlurred && this.props.accountInfo.userType < 5));
            }

            if (this.props.selectedItems.length === 1) {
                genItems.push((<MetricsFlashItem onClick={this.props.promptForLongData.bind(null, this.props.selectedItems[0])} closeMenuOnClick icon="timeline" text="Deep Analysis" add={''} />));
            }

            switch (this.props.screenContext.screen) {
                case 'locs':
                    if (this.props.selectedItems.length > 0) {
                        // chatAdd = this.props.selectedItems.length.toString();
                        chatAdd = '';
                    }
                    if (this.props.isPhone) { genItems.push((<MetricsFlashItem onClick={this.toggleSearch} closeMenuOnClick icon="search" text="Search" add={''} />)); }
                    if (this.props.selectedItems.length === 1) {
                        genItems.push((<MetricsFlashItem onClick={this.props.textPeople} closeMenuOnClick icon="chat" text={"Text " + this.props.selectedItems[0].name} add={chatAdd} />));
                        genItems.push((<MetricsFlashItem onClick={this.props.callPeople} closeMenuOnClick icon="phone" text={"Call " + this.props.selectedItems[0].name} add={''} />));
                    }
                    if (this.props.blastData != undefined && this.props.screenContext != undefined && this.props.blastData[this.props.screenContext.groupKey] != undefined && this.props.selectedItems.length != this.props.blastData[this.props.screenContext.groupKey].length) {
                        genItems.push((<MetricsFlashItem onClick={this.props.selectAllItems} closeMenuOnClick icon="check_box" text="Select All" add={''} />));
                    }
                    if (this.props.selectedItems.length > 0) {
                        genItems.push((<MetricsFlashItem onClick={this.props.clearSelectedItems} closeMenuOnClick icon="check_box_outline_blank" text="Clear Selected" add={''} />));
                    }
                    break;
                case 'loc':
                    if (this.props.isPhone) { genItems.push((<MetricsFlashItem onClick={this.toggleSearch} closeMenuOnClick icon="search" text="Search" add={''} />)); }
                    genItems.push((<MetricsFlashItem onClick={this.props.textPeople} closeMenuOnClick icon="chat" text={"Text " + this.props.screenContext.groupKey} add={''} />));
                    genItems.push((<MetricsFlashItem onClick={this.props.callPeople} closeMenuOnClick icon="phone" text={"Call " + this.props.screenContext.groupKey} add={''} />));
                    if (this.props.selectedItems.length > 0) {
                        genItems.push((<MetricsFlashItem onClick={this.props.clearSelectedItems} closeMenuOnClick icon="check_box_outline_blank" text="Clear Selected" add={''} />));
                    }
                    break;
                case 'emps':
                    if (this.props.selectedItems.length > 0) {
                        // chatAdd = this.props.selectedItems.length.toString();
                        chatAdd = '';
                    }
                    if (this.props.isPhone) { genItems.push((<MetricsFlashItem onClick={this.toggleSearch} closeMenuOnClick icon="search" text="Search" add={''} />)); }
                    if (isNotBlurred) {
                        genItems.push((<MetricsFlashItem onClick={this.props.textPeople} closeMenuOnClick icon="chat" text={this.props.selectedItems.length === 1 ? "Text " + this.props.selectedItems[0].name : this.props.selectedItems.length > 1 ? 'Text Selected' : 'Text All'} add={chatAdd} />));
                    }
                    if (this.props.selectedItems.length == 1 && (!this.props.accountInfo.isEmployeeBlurred || (this.props.accountInfo.isEmployeeBlurred && this.props.accountInfo.userType < 5))) {
                        genItems.push((<MetricsFlashItem onClick={this.props.callPeople} closeMenuOnClick icon="smartphone" text={"Call " + this.props.selectedItems[0].name} add={''} />));
                    }
                    if (this.props.blastData != undefined && this.props.screenContext != undefined && this.props.blastData[this.props.screenContext.groupKey] != undefined && this.props.selectedItems.length != this.props.blastData[this.props.screenContext.groupKey].length) {
                        genItems.push((<MetricsFlashItem onClick={this.props.selectAllItems} closeMenuOnClick icon="check_box" text="Select All" add={''} />));
                    }
                    if (this.props.selectedItems.length > 0) {
                        genItems.push((<MetricsFlashItem onClick={this.props.clearSelectedItems} closeMenuOnClick icon="check_box_outline_blank" text="Clear Selected" add={''} />));
                    }
                    break;
                case 'emp':
                    if (this.props.isPhone) { genItems.push((<MetricsFlashItem onClick={this.toggleSearch} closeMenuOnClick icon="search" text="Search" add={''} />)); }
                    if (this.props.meKey != this.props.screenContext.groupKey && isNotBlurred) {
                        genItems.push((<MetricsFlashItem onClick={this.props.textPeople} closeMenuOnClick icon="chat" text={"Text " + this.props.screenContext.groupKey} add={''} />));
                        genItems.push((<MetricsFlashItem onClick={this.props.callPeople} closeMenuOnClick icon="smartphone" text={"Call " + this.props.screenContext.groupKey} add={''} />));
                    }
                    if (this.props.selectedItems.length > 0) {
                        genItems.push((<MetricsFlashItem onClick={this.props.clearSelectedItems} closeMenuOnClick icon="check_box_outline_blank" text="Clear Selected" add={''} />));
                    }
                    break;
                case 'allemp':
                    if (this.props.isPhone) { genItems.push((<MetricsFlashItem onClick={this.toggleSearch} closeMenuOnClick icon="search" text="Search" add={''} />)); }
                    if (this.props.meKey != this.props.screenContext.groupKey && isNotBlurred) {
                        genItems.push((<MetricsFlashItem onClick={this.props.textPeople} closeMenuOnClick icon="chat" text={"Text " + this.props.screenContext.groupKey} add={''} />));
                        genItems.push((<MetricsFlashItem onClick={this.props.callPeople} closeMenuOnClick icon="smartphone" text={"Call " + this.props.screenContext.groupKey} add={''} />));
                    }
                    if (this.props.selectedItems.length > 0) {
                        genItems.push((<MetricsFlashItem onClick={this.props.clearSelectedItems} closeMenuOnClick icon="check_box_outline_blank" text="Clear Selected" add={''} />));
                    }
                    break;
                case 'allemps':
                    if (this.props.selectedItems.length > 0) {
                        //chatAdd = this.props.selectedItems.length.toString();
                        chatAdd = '';
                    }
                    if (this.props.isPhone) { genItems.push((<MetricsFlashItem onClick={this.toggleSearch} closeMenuOnClick icon="search" text="Search" add={''} />)); }
                    if (this.props.selectedItems.length > 0 && isNotBlurred) {
                        genItems.push((<MetricsFlashItem onClick={this.props.textPeople} closeMenuOnClick icon="chat" text={this.props.selectedItems.length === 1 ? "Text " + this.props.selectedItems[0].name : 'Text Selected'} add={chatAdd} />));
                    }
                    if (this.props.selectedItems.length == 1 && isNotBlurred) {
                        genItems.push((<MetricsFlashItem onClick={this.props.callPeople} closeMenuOnClick icon="smartphone" text={"Call " + this.props.selectedItems[0].name} add={''} />));
                    }
                    if (this.props.blastData != undefined && this.props.screenContext != undefined && this.props.blastData[this.props.screenContext.groupKey] != undefined && this.props.selectedItems.length != this.props.blastData[this.props.screenContext.groupKey].length) {
                        genItems.push((<MetricsFlashItem onClick={this.props.selectAllItems} closeMenuOnClick icon="check_box" text="Select All" add={''} />));
                    }
                    if (this.props.selectedItems.length > 0) {
                        genItems.push((<MetricsFlashItem onClick={this.props.clearSelectedItems} closeMenuOnClick icon="check_box_outline_blank" text="Clear Selected" add={''} />));
                    }
                    break;
                case 'dists':
                    if (this.props.blastData != undefined && this.props.screenContext != undefined && this.props.blastData[this.props.screenContext.groupKey] != undefined && this.props.selectedItems.length != this.props.blastData[this.props.screenContext.groupKey].length) {
                        genItems.push((<MetricsFlashItem onClick={this.props.selectAllItems} closeMenuOnClick icon="check_box" text="Select All" add={''} />));
                    }
                    if (this.props.selectedItems.length > 0) {
                        genItems.push((<MetricsFlashItem onClick={this.props.clearSelectedItems} closeMenuOnClick icon="check_box_outline_blank" text="Clear Selected" add={''} />));
                    }
                    break;
                case 'dist':
                    if (this.props.selectedItems.length > 0) {
                        genItems.push((<MetricsFlashItem onClick={this.props.clearSelectedItems} closeMenuOnClick icon="check_box_outline_blank" text="Clear Selected" add={''} />));
                    }
                    break;
                case 'distLocs':
                    if (this.props.selectedItems.length > 0) {
                        // chatAdd = this.props.selectedItems.length.toString();
                        chatAdd = '';
                    }
                    if (this.props.isPhone) { genItems.push((<MetricsFlashItem onClick={this.toggleSearch} closeMenuOnClick icon="search" text="Search" add={''} />)); }
                    if (this.props.selectedItems.length === 1) {
                        genItems.push((<MetricsFlashItem onClick={this.props.textPeople} closeMenuOnClick icon="chat" text={"Text " + this.props.selectedItems[0].name} add={chatAdd} />));
                        genItems.push((<MetricsFlashItem onClick={this.props.callPeople} closeMenuOnClick icon="phone" text={"Call " + this.props.selectedItems[0].name} add={''} />));
                    }
                    if (this.props.blastData != undefined && this.props.screenContext != undefined && this.props.blastData[this.props.screenContext.groupKey] != undefined && this.props.selectedItems.length != this.props.blastData[this.props.screenContext.groupKey].length) {
                        genItems.push((<MetricsFlashItem onClick={this.props.selectAllItems} closeMenuOnClick icon="check_box" text="Select All" add={''} />));
                    }
                    if (this.props.selectedItems.length > 0) {
                        genItems.push((<MetricsFlashItem onClick={this.props.clearSelectedItems} closeMenuOnClick icon="check_box_outline_blank" text="Clear Selected" add={''} />));
                    }
                    break;
            }
        }

        if (this.pm.hasAccess(this.pm.PERMISSIONS.METRICS_FORCEBLAST))
            genItems.push((<MetricsFlashItem onClick={this.props.forceBlast} closeMenuOnClick icon="bomb" text="Force Blast" add={''} />));

        return genItems;
    }

    //<Button className="metrics-top-bar-search-gotome">Go To Me</Button> -- removed for now
    render() {
        if (this.props.isPhone) {
            return this.renderPhone();
        } else {
            return this.renderDesktop();
        }
    }

    renderPhone() {
        let outerStyle = {};
        if (!this.props.isScrollTop) {
            outerStyle.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.16), 0 3px 3px rgba(0, 0, 0, 0.23)';
        }

        let outerClass = "metrics-top-bar-outer";
        if (this.props.isScrollDirectionDown) {
            outerClass += " metrics-top-bar-outer-shrunk"
        }

        let metricOptionStrings = this.props.activeListContent;

        if (this.props.userType === 5 && this.props.primaryLocation != undefined && this.props.primaryLocation.isEmployeeLocked) {
            let tempList = [];

            if (this.props.locationList.length > 1) {
                tempList.push('All');
            }
            for (var i = 0; i < this.props.locationList.length; i++) {
                tempList.push(this.props.locationList[i]);
            }
            metricOptionStrings = tempList;
        }

        let isBlurred = false;
        if (this.props.accountInfo != undefined && this.props.accountInfo != null && this.props.accountInfo.userType === 5 &&
            (this.props.screenContext.screen === 'emp' || this.props.screenContext.screen === 'allemp')) {
            isBlurred = this.props.accountInfo.isEmployeeBlurred === null ? false : this.props.accountInfo.isEmployeeBlurred;
        }

        let metricOptionDefaultValue = null;
        let metricOptionJsx = null;
        if (this.props.blastFilter != undefined && this.props.screenContext.groupKey != undefined) {
            metricOptionDefaultValue = this.props.screenContext.groupKey;
            metricOptionJsx = (
                <ZSelectField
                    id="metrics-top-bar-select-field"
                    placeholder=""
                    defaultValue={metricOptionDefaultValue}
                    className="md-cell metrics-top-bar-selector"
                    menuItems={metricOptionStrings}
                    position={SelectField.Positions.BELOW}
                    simplifiedMenu={true}
                    stripActiveItem={false}
                    onChange={this.props.changeTopSelector}
                    value={this.props.screenContext.groupKey}
                    activeColor="rgba(0, 126, 181, 1)"
                    isBlurred={isBlurred}
                    meKey={this.props.meKey}
                    isBlocked
                />
            );
        }

        let flashMenuItems = this.generateFlashItems();

        let normalStyle = {};
        let searchStyle = {};
        let searchInnerStyle = {};
        let dropClass = 'metrics-top-bar-search-dropdown-container';
        if (this.props.isSearchMode) {
            //normalStyle.top = 0;
            normalStyle.left = '100%';

            //searchStyle.top = '0.9rem';
            searchStyle.left = 0;

            if (this.state.isSearchDropped) {
                searchInnerStyle.height = '7.8rem';
                dropClass += ' metrics-top-bar-search-dropdown-container--active'
            }
        }

        if (this.state.isSearchFocused) {
            searchInnerStyle.boxShadow = '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)';
        }

        let searchTopText = '';
        switch (this.props.searchTop) {
            case 0: searchTopText = "All"; break;
            case 10: searchTopText = 'Top 10'; break;
            case 25: searchTopText = 'Top 25'; break;
            case 100: searchTopText = 'Top 100'; break;
        }

        let upperLeftBtn = null;
        if (this.props.screenContext.showBack)
            upperLeftBtn = <div className="metrics-top-bar-menu-button material-icons" onClick={this.props.back}>arrow_back</div>
        else
            upperLeftBtn = <div className="metrics-top-bar-menu-button material-icons" onClick={this.props.toggleNav}>menu</div>


        let killDropdown = (this.props.blastData === undefined || this.props.blastData === null || Object.keys(this.props.blastData).length === 0 ||
            this.props.blastData[this.props.screenContext.groupKey] === undefined || this.props.blastData[this.props.screenContext.groupKey].length === 0);


        return (
            <div className={outerClass} style={outerStyle}>
                <div className="metrics-top-bar-normal-container" style={normalStyle} onClick={this.props.isScrollDirectionDown ? this.props.scrollToTop : null}>
                    {upperLeftBtn}
                    <div className="metrics-top-bar-selector-container">
                        {killDropdown ? null : metricOptionJsx}
                    </div>
                    {
                        flashMenuItems.length === 0 ? null : (
                            <ZDropdownMenu
                                id="metrics-top-bar-flashmenu"
                                className="metrics-top-bar-flashmenu-button"
                                menuItems={flashMenuItems}
                                isBlocked={true}
                            >
                                <div className="metrics-top-bar-flashmenu-icon material-icons">flash_on</div>
                            </ZDropdownMenu>
                        )
                    }
                </div>
                <div className="metrics-top-bar-search-container" style={searchStyle}>
                    <div className="metrics-top-bar-search-inner" style={searchInnerStyle}>
                        <div className="metrics-top-bar-search-back material-icons" onClick={this.toggleSearch}>arrow_back</div>
                        <div className="metrics-top-bar-search-input-container">
                            {
                                killDropdown ? null :
                                    <TextField
                                        id="search-input"
                                        className="metrics-top-bar-search-input"
                                        placeholder="Search Insights"
                                        type="text"
                                        value={this.props.searchText}
                                        onChange={this.handleSearch}
                                        onFocus={this.handleSearchFocus.bind(null, true)}
                                        onBlur={this.handleSearchFocus.bind(null, false)}
                                    />
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderDesktop() {
        let outerStyle = {};
        if (!this.props.isScrollTop) {
            outerStyle.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.16), 0 3px 3px rgba(0, 0, 0, 0.23)';
        }

        let outerClass = "metrics-top-bar-outer";

        let metricOptionStrings = this.props.activeListContent;

        if (this.props.userType === 5 && this.props.primaryLocation != undefined && this.props.primaryLocation.isEmployeeLocked) {
            let tempList = [];

            if (this.props.locationList.length > 1) {
                tempList.push('All');
            }
            for (var i = 0; i < this.props.locationList.length; i++) {
                tempList.push(this.props.locationList[i]);
            }
            metricOptionStrings = tempList;
        }

        let isBlurred = false;
        if (this.props.accountInfo != undefined && this.props.accountInfo != null && this.props.accountInfo.userType === 5 &&
            (this.props.screenContext.screen === 'emp' || this.props.screenContext.screen === 'allemp')) {
            isBlurred = this.props.accountInfo.isEmployeeBlurred === null ? false : this.props.accountInfo.isEmployeeBlurred;
        }

        let metricOptionDefaultValue = null;
        let metricOptionJsx = null;
        if (this.props.blastFilter != undefined && this.props.screenContext.groupKey != undefined) {
            metricOptionDefaultValue = this.props.screenContext.groupKey;
            metricOptionJsx = (
                <ZSelectField
                    id="metrics-top-bar-select-field"
                    placeholder=""
                    defaultValue={metricOptionDefaultValue}
                    className="md-cell metrics-top-bar-selector"
                    menuItems={metricOptionStrings}
                    position={SelectField.Positions.BELOW}
                    simplifiedMenu={true}
                    stripActiveItem={false}
                    onChange={this.props.changeTopSelector}
                    value={this.props.screenContext.groupKey}
                    activeColor="rgba(0, 126, 181, 1)"
                    isBlurred={isBlurred}
                    meKey={this.props.meKey}
                    isBlocked
                />
            );
        }



        let peekOptionStrings = this.props.peekListContent;

        let peekIsBlurred = false;
        if (this.props.accountInfo != undefined && this.props.accountInfo != null && this.props.accountInfo.userType === 5 &&
            this.props.peekScreenContext != undefined && this.props.peekScreenContext != null &&
            (this.props.peekScreenContext.screen === 'emp' || this.props.peekScreenContext.screen === 'allemp')) {
            peekIsBlurred = this.props.accountInfo.isEmployeeBlurred === null ? false : this.props.accountInfo.isEmployeeBlurred;
        }

        let peekOptionDefaultValue = null;
        let peekOptionJsx = null;
        if (this.props.canPeek && this.props.blastFilter != undefined && this.props.peekScreenContext != null && this.props.peekScreenContext.groupKey != undefined) {
            peekOptionDefaultValue = this.props.peekScreenContext.groupKey;
            peekOptionJsx = (
                <ZSelectField
                    id="metrics-top-bar-select-field-peek"
                    placeholder=""
                    defaultValue={peekOptionDefaultValue}
                    className="md-cell metrics-top-bar-selector"
                    menuItems={peekOptionStrings}
                    position={SelectField.Positions.BELOW}
                    simplifiedMenu={true}
                    stripActiveItem={false}
                    onChange={this.props.changePeekTopSelector}
                    value={this.props.peekScreenContext.groupKey}
                    activeColor="rgba(0, 126, 181, 1)"
                    isBlurred={peekIsBlurred}
                    meKey={this.props.meKey}
                    isBlocked
                />
            );
        }

        let peekKillDropdown = (this.props.peekData === undefined || this.props.peekData === null || this.props.peekData.length === 0);




        let flashMenuItems = this.generateFlashItems();

        let searchInnerStyle = {};
        let peekSelectorStyle = {};
        if (this.state.isSearchFocused) {
            searchInnerStyle.boxShadow = '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)';
        }
        if (this.props.rightOptions.peek.active && this.props.peekSelectorActive) {
            searchInnerStyle.top = '-4.1rem';
            searchInnerStyle.opacity = '0';
            searchInnerStyle.pointerEvents = 'none';
            peekSelectorStyle.top = '0rem';
            peekSelectorStyle.opacity = '1';
        } else {
            searchInnerStyle.top = '0.7rem';
            searchInnerStyle.opacity = '1';
            peekSelectorStyle.top = '-5.5rem';
            peekSelectorStyle.opacity = '0';
            peekSelectorStyle.pointerEvents = 'none';
        }

        let upperLeftBtn = null;
        if (this.props.screenContext.showBack)
            upperLeftBtn = <div className="metrics-top-bar-menu-button material-icons" onClick={this.props.back}>arrow_back</div>
        else
            upperLeftBtn = <div className="metrics-top-bar-menu-button material-icons" onClick={this.props.toggleNav}>menu</div>


        let killDropdown = (this.props.blastData === undefined || this.props.blastData === null || Object.keys(this.props.blastData).length === 0 ||
            this.props.blastData[this.props.screenContext.groupKey] === undefined || this.props.blastData[this.props.screenContext.groupKey].length === 0);



        return (
            <div className={outerClass} style={outerStyle}>
                <div className="metrics-top-bar-normal-container" onClick={this.props.isScrollDirectionDown ? this.props.scrollToTop : null}>
                    {upperLeftBtn}
                    <div className="metrics-top-bar-selector-container">
                        {killDropdown ? null : metricOptionJsx}
                    </div>
                    <div className="metrics-top-bar-search-inner" style={searchInnerStyle}>
                        <div className="metrics-top-bar-search-input-container">
                            {
                                killDropdown ? null :
                                    <TextField
                                        id="search-input"
                                        className="metrics-top-bar-search-input"
                                        placeholder="Search Insights"
                                        type="text"
                                        value={this.props.searchText}
                                        onChange={this.handleSearch}
                                        onFocus={this.handleSearchFocus.bind(null, true)}
                                        onBlur={this.handleSearchFocus.bind(null, false)}
                                    />
                            }
                        </div>
                    </div>
                    <div className={"metrics-top-bar-selector-container peek"} style={peekSelectorStyle}>
                        {peekKillDropdown ? null : peekOptionJsx}
                    </div>
                    {
                        flashMenuItems.length === 0 ? null : (
                            <ZDropdownMenu
                                id="metrics-top-bar-flashmenu"
                                className="metrics-top-bar-flashmenu-button"
                                menuItems={flashMenuItems}
                                isBlocked={true}
                            >
                                <div className="metrics-top-bar-flashmenu-icon material-icons">flash_on</div>
                            </ZDropdownMenu>
                        )
                    }
                </div>
            </div>
        );
    }
}
